if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.productId = this.getAttribute('data-product-id');
    }
  
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
  
    showActiveMedia() {
      const activeMediaId = this.openedBy.getAttribute("data-media-id");
      const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
  
      const activeElement = activeMedia || this.querySelector('[data-media-id]');
      if (!activeMedia) {
        console.warn(`No se encontró medio con id ${activeMediaId} para el producto ${this.productId}. Mostrando el primer medio disponible.`);
      }
      if (!activeElement) {
        console.error(`No se encontraron medios en el modal para el producto ${this.productId}.`);
        return;
      }

      this.querySelectorAll(`[data-media-id]`).forEach((element) => {
        element.classList.toggle('active', element === activeElement);
      });

      // Situar el scroll del modal en la imagen pulsada (centrada).
      // Antes se calculaba scrollTop solo con la altura de la imagen, sin
      // sumar su posicion dentro del modal, asi que siempre acababa
      // mostrando la primera imagen; y el scrollIntoView "smooth" quedaba
      // anulado por ese scrollTop.
      const container = this.querySelector('[role="document"]');
      if (container) {
        const containerRect = container.getBoundingClientRect();
        const mediaRect = activeElement.getBoundingClientRect();
        const mediaTop = mediaRect.top - containerRect.top + container.scrollTop;
        const mediaLeft = mediaRect.left - containerRect.left + container.scrollLeft;
        container.scrollTop = mediaTop + (activeElement.offsetHeight - container.clientHeight) / 2;
        container.scrollLeft = mediaLeft + (activeElement.offsetWidth - container.clientWidth) / 2;
      } else {
        activeElement.scrollIntoView({ block: 'center' });
      }
    }
  });
}